module.exports = __webpack_public_path__ + "img/v.12241ae7.jpg";